import TransferOrder from "./Transfer";

const TransferOrderContainer = () => <TransferOrder/>;

export default TransferOrderContainer;
